export function footerWechat() {
    const $body = $("body");
    const weChatLink = $(".footer .wechat-link");
    weChatLink.on("click", function (e) {
        if ($body.hasClass("no-touch")) {
            e.preventDefault();
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/footerWechat.js